import { white, black } from '../common/colors';

export default {
  common: {
    black,
    white,
    neutral: '#E4E7EB',
    muted: '#9EA0A4'
  },
  primary: {
    contrastText: white,
    main: '#3d0ad6',
    light: '#bfb2ff',
    dark: '#0d0829'
  },
  secondary: {
    contrastText: white,
    main: '#41e7b1',
    light: '',
    dark: '#207559'
  },
  success: {
    contrastText: black,
    main: '#41e7b1',
    light: '#F1FAF5',
    dark: '#00783E'
  },
  info: {
    contrastText: white,
    main: '#0d0829',
    light: '#F1FBFC',
    dark: '#007489'
  },
  warning: {
    contrastText: black,
    main: '#FFB822',
    light: '##ff9116',
    dark: '#95591E'
  },
  danger: {
    contrastText: black,
    main: '#ff4745',
    light: '#FEF6F6',
    dark: '#BF0E08'
  },
  text: {
    primary: '#12161B',
    secondary: '#4a4a4a',
    disabled: '#A6B1BB'
  },
  background: {
    default: white,
    dark: '#172B4D',
    paper: white
  },
  border: '#DFE3E8',
  divider: '#DFE3E8'
};